import httpbaseURL from "../common/axios";
class SupplierPrePaymentService {
  CreateData(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/SupplierPrepayment/Create", doc);
  }
  GetList() {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPrepayment/List");
  }

  GetBySupplierId(HospitalId, BranchId, SupplierId, StoreBrMapId) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPrepayment/GetBySupplierId?HospitalId=" + HospitalId + "&BranchId=" + BranchId + "&SupplierId=" + SupplierId + "&StoreBrMapId=" + StoreBrMapId);
  }
  GetSupplierDetailsList(HId, BId, StoreBranchMapId) {
    debugger
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPrepayment/SupplierDetailsList?HospitalId=" + HId + "&BranchId=" + BId + "&StoreBranchMapId=" + StoreBranchMapId);
  }
  GetData(Id, HId, BId) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPrepayment/Get?PrepaymentID=" + Id + "&HospitalId=" + HId + "&BranchId=" + BId);
  }
  UpdateApprovalStatus(Id, IsApproved) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPrepayment/UpdateApprovalStatus?PrepaymentID=" + Id + "&IsApproved=" + IsApproved);
  }
  UpdateData(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/SupplierPrepayment/Update", doc);
  }
  DeleteData(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/SupplierPrepayment/Delete?PrepaymentID=" + doc
    );
  }

}
export default new SupplierPrePaymentService();
